import { proApi } from "@/lib/proApi";
import PlatzreifeBoard from "@/components/platzreife/PlatzreifeBoard";

export default function ProPlatzreife() {
  return (
    <div data-testid="pro-platzreife-page">
      <PlatzreifeBoard client={proApi} base="/pro" kicker="// ZENTRALE PLATZREIFE-AKTE" />
    </div>
  );
}
